<template>
  <div>
    <Banner background="red" />

    <UserResume
      :total-courses="numberOfCourses"
      :total-students="3"
      :rating="5"
    />

    <UserAbout />

    <Courses :courses="courses" />

    <Testimonials :testimonials="avaliacoes" />
  </div>
</template>

<script>
import Banner from '@/components/atomic/templates/Banner.vue';
import UserResume from '@/components/atomic/templates/UserResume.vue';
import UserAbout from '@/components/atomic/templates/UserAbout.vue';
import Courses from '@/components/atomic/templates/Courses.vue';
import Testimonials from '@/components/atomic/templates/Testimonials.vue';

import { mapActions } from 'vuex';

export default {
  name: 'LandingPage',

  components: {
    Banner,
    UserResume,
    UserAbout,
    Courses,
    Testimonials,
  },

  data() {
    return {
      courses: [],
      avaliacoes: [
        {
          id: '',
          img: require('@/assets/avatar/avatar.svg'),
          name: 'Luís Carlos',
          date: '03 Fev 2021, 10:26 PM',
          comment:
            'Apesar de eu ter realmente demorado a chegar no fim, é um bom curso. O instrutor passa por todas as etapas do processo de criação e explica cada um deles claramente.',
        },
        {
          id: '',
          img: require('@/assets/avatar/avatar.svg'),
          name: 'Luís Carlos',
          date: '03 Fev 2021, 10:26 PM',
          comment:
            'Apesar de eu ter realmente demorado a chegar no fim, é um bom curso. O instrutor passa por todas as etapas do processo de criação e explica cada um deles claramente.',
        },
        {
          id: '',
          img: require('@/assets/avatar/avatar.svg'),
          name: 'Luís Carlos',
          date: '03 Fev 2021, 10:26 PM',
          comment:
            'Apesar de eu ter realmente demorado a chegar no fim, é um bom curso. O instrutor passa por todas as etapas do processo de criação e explica cada um deles claramente.',
        },
        {
          id: '',
          img: require('@/assets/avatar/avatar.svg'),
          name: 'Luís Carlos',
          date: '03 Fev 2021, 10:26 PM',
          comment:
            'Apesar de eu ter realmente demorado a chegar no fim, é um bom curso. O instrutor passa por todas as etapas do processo de criação e explica cada um deles claramente.',
        },
      ],
    };
  },

  computed: {
    numberOfCourses() {
      return this.courses.length;
    },
  },

  async mounted() {
    this.courses = await this.getMyCourses();
    await this.handleAvaliations();
    console.log(this.avaliacoes)
  },

  methods: {
    ...mapActions('teacher', ['getMyCourses']),
    async handleAvaliations(){
      this.avaliacoes.filter(avaliacao =>{
        this.courses.avaliations.map( a =>{
          avaliacao.comment = a.comment;
          avaliacao.id = a.id;
        })
      })
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  #resume {
    padding-left: 0;
    margin-left: 0;
    margin-right: 0;

    .position {
      display: none;
    }

    .cards {
      flex-direction: column;
      margin-top: 0;
    }
  }

  #about {
    .main {
      padding: 30px;
      flex-direction: column;

      .personal-infos {
        .nome {
          font-size: 36px;
        }
        .profissao {
          font-size: 24px;
        }

        .location,
        .email,
        .phone {
          font-size: 22px;
        }
      }
    }

    .description {
      display: none;
    }
  }

  #cursos {
    .content {
      .novo-curso {
        display: none;
      }
    }
  }
}
</style>
